import { useMemo } from "react";

import type { Member, SettlementCategory } from "../types";

/**
 * Memoised lookup Maps for members and categories. Used by ExpensesTable,
 * ViewInvoiceExpensesDialog, AdjustSplitDialog and other places that
 * need O(1) lookup by `userId` / `categoryId`. Previously each call site
 * built these `new Map(...)` per render; the hook keeps the references
 * stable across renders as long as the source arrays don't change.
 */
export function useCategoryMaps(
  members: Member[],
  categories: SettlementCategory[],
): {
  memberMap: Map<string, Member>;
  categoryMap: Map<string, SettlementCategory>;
} {
  const memberMap = useMemo(() => new Map(members.map((m) => [m.userId, m])), [members]);
  const categoryMap = useMemo(() => new Map(categories.map((c) => [c.id, c])), [categories]);
  return { memberMap, categoryMap };
}
